<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="dropdown-file">
    <div class="file-object">
      <div class="option-wrapper has-side-bars">
        <div class="info-wrapper">
          <div class="icon-file" />
          <!-- eslint-disable-next-line vue/no-parsing-error -->
          <div class="file-name">{{ (isMobile && dataInfo.name.length <= 30 || !isMobile ? dataInfo.name : (dataInfo.name.slice(0, 27) + '...' + '.' + dataInfo.format.toLowerCase())) }}</div>
        </div>
        <div class="buttons-wrapper">
          <div
            v-if="dataApi"
            class="chevron-icon"
            :class="predefinedStateFiles && 'open-file'"
            @click="toggleFile()"
          />
          <div class="circle-button">
            <div class="icon-submenu" @click="showMenuOp" />
            <div ref="menuOp" v-click-outside="hideMenuOp" class="submenu-options">
              <div class="submenu-option" @click="changeDetailTableInfoAndOpenModal(dataInfo)">
                <div class="icon-details" />
                <div>{{ $t('file_details') }}</div>
              </div>
              <div v-if="dataApi" class="submenu-option" @click="modalOpenApi(dataInfo)">
                <div class="icon-api" />
                <div>{{ $t('data_api') }}</div>
              </div>
              <div @click="() => download(dataInfo)">
                <div class="submenu-option">
                  <div class="icon-download" />
                  <div>{{ $t('download') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dataApi" class="file-open-details" :class="predefinedStateFiles ? 'file-grow' : 'file-hidden'">
      <FileContentTabs :only-table="true">
        <template v-slot:table-details>
          <MicrodataTable v-if="predefinedStateFiles" :table-id="fileId" />
        </template>
      </FileContentTabs>
    </div>
  </div>
</template>

<script>
import MicrodataTable from '../table/MicrodataTable.vue'
import ClickOutside from 'vue-click-outside'
import FileContentTabs from './FileContentTabs.vue'
import $ from 'jquery'
import { savedownload } from '../../services/api'
/**
 * DropDownFile view
 * @example [none]
 */
export default {
  name: 'DropDownFile',
  components: { FileContentTabs, MicrodataTable },
  directives: { ClickOutside },
  props: {
    /**
     * True if file has data api information
     */
    dataApi: {
      type: Boolean,
    },
    /**
     * Object information of the file
     */
    dataInfo: {
      type: Object,
    },

    /**
     * Array file of details table
     */
    dataTableFile: {
      type: Array,
    },
    /**
     * ID of the dropdown file
     */
    fileId: {
      type: String,
    },
  },
  data() {
    return {
      //state refers to open(true) o close(false)
      predefinedStateFiles: false,
    }
  },
  methods: {
    download(data) {
      document.open(data.url, "", "noopener=true")
      savedownload(this.$route.params.lang, this.$route.params.cardId, data.name)
    },
    modalOpenApi(file) {
      //GRJ2EE-8911 (Modificado la manera que se abre)
      this.$emit('change-detail-table-info', file)
      this.show('modal-microdata-api')
      this.hideMenuOp()
    },
    modalCloseApi() {
      this.$modal.hide('modal-microdata-api')
    },
    hideMenuOp() {
      $(this.$refs.menuOp).removeClass('visible')
    },
    showMenuOp() {
      setTimeout(() => {
        $(this.$refs.menuOp).addClass('visible')
      }, 1)
    },
    /**
     * Toggle a file if it has information (open the details view)
     * @public This is a public method
     */
    toggleFile() {
      this.predefinedStateFiles = !this.predefinedStateFiles
    },
    /**
     * Shows the modal recived by param
     * @param {String} val id of modal to open
     * @public This is a public method
     */
    show(val) {
      this.$modal.show(val)
    },
    /**
     * Hide the modal recived by param
     * @param {String} val id of modal to close
     * @public This is a public method
     */
    hide(val) {
      this.$modal.hide(val)
    },
    /**
     * Change the information of table details and open the modal
     * @param {Object} file information of file clicked
     * @public This is a public method
     */
    changeDetailTableInfoAndOpenModal(file) {
      this.$emit('change-detail-table-info', file)
      this.show('modal-file-details')
      this.hideMenuOp()
    },
  },
}
</script>

<style lang="stylus" scoped>
.file-details-block
  display: flex
  justify-content: center
  align-items: center
  min-height: 200px
  width: 100%
  background-color: lightgrey

.file-open-details
  width: 100%
  background-color: white

.file-hidden
  display: none

.file-grow
  transform-origin: top center
  animation: growDown 0.2s ease-in-out forwards

@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)

.file-object
  padding-top: vw(30px)
  padding-bottom: vw(30px)
  border-top: 1px solid $bcn-grey
  border-bottom: 1px solid $bcn-other-grey
  background-color: #fff

  .option-wrapper
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%

    .buttons-wrapper
      display: flex
      align-items: center
      gap: vw(5px)

      .mobile &
        gap: 0

      .circle-button
        position: relative
        display: flex
        justify-content: center
        align-items: center
        width: vw(32px)
        height: vw(32px)
        border-radius: 50%
        background-color: $grey-dark
        cursor: pointer

        .mobile &
          background-color: transparent

        .submenu-options
          position: absolute
          top: vw(34px)
          right: 0
          z-index: 2
          display: none
          flex-direction: column
          min-width: vw(120px)
          border: 1px solid $bcn-grey-3
          border-radius: 5px
          background-color: white
          gap: vw(3px)

          &.visible
            display: flex

          .submenu-option:hover
            border-radius: 5px
            background-color: $bcn-grey

          .submenu-option
            m-font-size(14, 22)
            display: flex
            align-items: center
            padding: vw(5px)
            gap: vw(4px)

            .icon-api
              m-icon("api", 16)

            .icon-download
              m-icon("download-black", 16, #000)

            .icon-details
              m-icon("info", 16)

        .icon-submenu
          m-icon("more-op", 18, #FFF)

          .mobile &
            m-icon("more-op-blue", 18, $corporate_color, false)

      .chevron-icon
        m-icon("chevron-up-blue", 26)
        margin-right: vw(15px)
        cursor: pointer
        transform: rotate(180deg)
        animation: 0.3s

      .open-file
        transform: rotate(0)
        animation-name: rotate

      @keyframes rotate
        from
          transform: rotate(180deg)

        to
          transform: rotate(0)

      .button-wrapp
        display: flex
        align-items: center
        padding: vw(5px) vw(15px)
        border-radius: 3px
        background-color: $bcn-grey
        cursor: pointer
        gap: vw(8px)

        .icon-info
          m-icon("info", 16)

        .icon-download
          m-icon("arrow-downward", 16, $black)

        .icon-api
          m-icon("api", 16)

    .info-wrapper
      display: flex
      align-items: center
      gap: vw(10px)

      .icon-file
        m-icon("json-file", 22, #B4D7FF, false)

      .file-name
        m-font-size(24, 28)

        .mobile &
          m-font-size(16, 25)
</style>
